import React, { type PropsWithChildren } from 'react';
import ClientPageHeading from 'ts/common/components/ClientPageHeading';
import ClientPageLayout from 'ts/common/components/ClientPageLayout';
import { useTranslate } from 'ts/common/hooks';

interface Props {
    contract: SpApi.Client.IContract;
    contractUserEmail: string | null;
}

const PageContainer: React.FC<PropsWithChildren<Props>> = ({
    children,
    contract,
    contractUserEmail
}) => {
    const t = useTranslate('contract.pageContainer');

    const contractUserFirstName = contract.contacts?.find(
        (contact) => contact.email === contractUserEmail
    )?.firstName;

    return (
        <ClientPageLayout
            banner={
                <ClientPageHeading
                    subtitle={
                        contract.contacts?.[0]?.firstName
                            ? t('pleaseReviewAndSignContract')
                            : undefined
                    }
                >
                    {contractUserFirstName ? `HI, ${contractUserFirstName}` : contract.name}
                </ClientPageHeading>
            }
            headingText={contract.brandName}
        >
            {children}
        </ClientPageLayout>
    );
};

export default PageContainer;
